export const PaymentPlanActionTypes = {
    ASYNC_PAYMENT_PLANS: '@paymentPlan/ASYNC_PAYMENT_PLANS',
    GET_PAYMENT_PLANS: '@paymentPlan/GET_PAYMENT_PLANS',
    LOADING: '@paymentPlan/LOADING',
    ASYNC_PLAN: '@paymentPlan/PLAN',
    SET_PLAN: '@paymentPlan/GET_PLAN',
    GET_INSTALLMENTS: '@paymentPlan/GET_INSTALLMENTS',
    ASYNC_PAYMENT_METHOD: '@paymentPlan/ASYNC_PAYMENT_METHOD',
    LOADING_PAYMENT_METHOD: '@paymentPlan/LOADING_PAYMENT_METHOD',
    LOADING_DISABLE_PLAN: '@paymentPlan/LOADING_DISABLE_PLAN',
    ASYNC_DISABLE_PLAN: '@paymentPlan/ASYNC_DISABLE_PLAN',
    ASYNC_PAYMENT_PLANS_INSTALLMENT_DETAILS: '@paymentPlan/ASYNC_PAYMENT_PLANS_INSTALLMENT_DETAILS',
    GET_PAYMENT_PLANS_INSTALLMENT_DETAILS: '@paymentPlan/GET_PAYMENT_PLANS_INSTALLMENT_DETAILS',
    LOADING_INSTALLMENT_DETAILS: '@paymentPlan/LOADING_INSTALLMENT_DETAILS',
    ASYNC_PIX_STATUS: '@paymentPlan/ASYNC_PIX_STATUS',
    GET_PIX_STATUS: '@paymentPlan/GET_PIX_STATUS',
    LOADING_PIX: '@paymentPlan/LOADING_PIX',
    WEBHOOK_NOTIFICATIONS: '@paymentPlan/WEBHOOK_NOTIFICATIONS',
    WEBHOOK_NOTIFICATION_DETAILS: '@paymentPlan/WEBHOOK_NOTIFICATION_DETAILS',
    GET_WEBHOOK_NOTIFICATIONS: '@paymentPlan/GET_WEBHOOK_NOTIFICATIONS',
    GET_WEBHOOK_NOTIFICATION_DETAILS: '@paymentPlan/GET_WEBHOOK_NOTIFICATION_DETAILS',
    ASYNC_SUMMARY: '@paymentPlan/ASYNC_SUMMARY',
    GET_SUMMARY: '@paymentPlan/GET_SUMMARY',
    LOADING_SUMMARY: '@paymentPlan/LOADING_SUMMARY'
}

const INITIAL_STATE = {
    paymentPlans: [],
    plans: { items: [], total: 0 },
    plan: {},
    loading: true,
    installments: [],
    loadingPaymentMethod: false,
    loadingDisablePlan: false,
    installmentDetails: [],
    loadingInstallmentDetails: false,
    pixKey: null,
    loadingPix: false,
    webhookNotifications: [],
    webhookNotificationDetails: {},
    summary: {},
    summaryLoading: false,
};

export const PaymentPlan = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
      case PaymentPlanActionTypes.GET_PAYMENT_PLANS:
        return { ...state, plans: payload }
      case PaymentPlanActionTypes.LOADING:
        return { ...state, loading: payload }
      case PaymentPlanActionTypes.SET_PLAN:
        return { ...state, plan: payload }
      case PaymentPlanActionTypes.GET_INSTALLMENTS:
        return { ...state, installments: payload }
      case PaymentPlanActionTypes.LOADING_PAYMENT_METHOD:
        return { ...state, loadingPaymentMethod: payload }
      case PaymentPlanActionTypes.LOADING_DISABLE_PLAN:
        return { ...state, loadingDisablePlan: payload }
      case PaymentPlanActionTypes.LOADING_INSTALLMENT_DETAILS:
        return { ...state, loadingInstallmentDetails: payload }
      case PaymentPlanActionTypes.GET_PAYMENT_PLANS_INSTALLMENT_DETAILS: 
        return { ...state, installmentDetails: payload}
      case PaymentPlanActionTypes.GET_PIX_STATUS: 
        return { ...state, pixKey: payload}
      case PaymentPlanActionTypes.LOADING_PIX: 
        return { ...state, loadingPix: payload}
      case PaymentPlanActionTypes.GET_WEBHOOK_NOTIFICATIONS: 
          return { ...state, webhookNotifications: payload}
      case PaymentPlanActionTypes.GET_WEBHOOK_NOTIFICATION_DETAILS:
        return { ...state, webhookNotificationDetails: payload}
      case PaymentPlanActionTypes.GET_SUMMARY: 
        return { ...state, summary: payload}
      case PaymentPlanActionTypes.LOADING_SUMMARY: 
        return { ...state, summaryLoading: payload}
      default:
        return state;
    }
};

export const asyncPaymentPlans = (payload) => ({
    type: PaymentPlanActionTypes.ASYNC_PAYMENT_PLANS,
    payload
});

export const asyncPlan = (payload) => ({
  type: PaymentPlanActionTypes.ASYNC_PLAN,
  id: payload
});

export const setPlan = (payload) => ({
  type: PaymentPlanActionTypes.SET_PLAN,
  payload: payload
});

export const setInstallments = (payload) => ({
  type: PaymentPlanActionTypes.GET_INSTALLMENTS,
  payload: payload
});

export const setPlans = (payload) => ({
    type: PaymentPlanActionTypes.GET_PAYMENT_PLANS,
    payload
});

export const setLoading = (payload) => ({
  type: PaymentPlanActionTypes.LOADING,
  payload
});

export const asyncPaymentMethod = (payload) => ({
  type: PaymentPlanActionTypes.ASYNC_PAYMENT_METHOD,
  payload
});

export const setLoadingDisablePlan = (payload) => ({
  type: PaymentPlanActionTypes.LOADING_DISABLE_PLAN,
  payload
});

export const setLoadingGeneratePaymentMethod = (payload) => ({
  type: PaymentPlanActionTypes.LOADING_PAYMENT_METHOD,
  payload
});

export const asyncPixStatus = (payload) => ({
  type: PaymentPlanActionTypes.ASYNC_PIX_STATUS,
  payload
});

export const getPixData = (payload) => ({
  type: PaymentPlanActionTypes.GET_PIX_STATUS,
  payload
});

export const asyncDisablePlan = (payload) => ({
  type: PaymentPlanActionTypes.ASYNC_DISABLE_PLAN,
  payload
});

export const setLoadingInstallmentDetails = (payload) => ({
  type: PaymentPlanActionTypes.LOADING_INSTALLMENT_DETAILS,
  payload
});

export const asyncInstallmentDetails = (payload) => ({
  type: PaymentPlanActionTypes.ASYNC_PAYMENT_PLANS_INSTALLMENT_DETAILS,
  payload
});

export const getInstallmentDetails = (payload) => ({
  type: PaymentPlanActionTypes.GET_PAYMENT_PLANS_INSTALLMENT_DETAILS,
  payload
});

export const setLoadingPix = (payload) => ({
  type: PaymentPlanActionTypes.LOADING_PIX,
  payload
});

export const asyncWebhookNotifications = (payload) => ({
    type: PaymentPlanActionTypes.WEBHOOK_NOTIFICATIONS,
    payload
});

export const asyncWebhookNotificationDetails = (payload) => ({
    type: PaymentPlanActionTypes.WEBHOOK_NOTIFICATION_DETAILS,
    payload
});

export const getWebhookNotificationsData = (payload) => ({
  type: PaymentPlanActionTypes.GET_WEBHOOK_NOTIFICATIONS,
  payload
});

export const getWebhookNotificationDetailsData = (payload) => ({
  type: PaymentPlanActionTypes.GET_WEBHOOK_NOTIFICATION_DETAILS,
  payload
});

export const asyncSummary = (payload) => ({
  type: PaymentPlanActionTypes.ASYNC_SUMMARY,
  payload
});

export const getSummary = (payload) => ({
  type: PaymentPlanActionTypes.GET_SUMMARY,
  payload
});

export const setLoadingSummary = (payload) => ({
  type: PaymentPlanActionTypes.LOADING_SUMMARY,
  payload
});

export default PaymentPlan;
